import styled from "@emotion/styled";

export const Image = styled('img')({
  MozUserSelect: '-moz-none',
  KhtmlUserSelect: 'none',
  WebkitUserSelect: 'none',
  userSelect: 'none',
  '-o-user-select': 'none',
  pointerEvents: 'none',
  backgroundSize: "cover",
  "@media (min-width:320px)": {
    width: "130px",
    height: "100px",
  },
  "@media (min-width:1200px)": {
    width: "150px",
    height: "100px",
  },
});